export enum OutletTypesEnum {
    HOTEL = 1,
    DINING = 2,
    CASINO = 4,
    POOL = 8,
    GOLF = 16,
    SPA = 32,
    PARKING = 64,
    BAR = 128,
}
